import React, { useEffect, useMemo, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap is installed
import { MdOutlineAdd, MdOutlineDelete, MdOutlineEdit } from 'react-icons/md';
import { Breadcrumb, BreadcrumbItem, Modal } from 'reactstrap';
import { useNavigate } from 'react-router';
import { t } from 'i18next';
import i18n from 'src/i18n';
import "./question.css"
import { toast } from 'react-toastify';
import { fetchDataApi ,deleteQuestionApi} from 'src/services/question';
import { getUserInfo, getUserRolePermissions } from 'src/services/userServicer';
import { getReferences } from 'src/services/reference';
const QuestionTable = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [selectedQuestionId, setSelectedQuestionId] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const toggleModal = () => {
      setIsModalOpen(!isModalOpen);
    };

    const fetchQuestions = async () => {
      setLoading(true);
      try {
        const data = await fetchDataApi(`bank-questions?perPage=${pageSize}&pageNo=${page}&query=${searchTerm}`);
        if(data.success){
          setQuestions(data.data);
          setTotalPages(data.totalPages); // Ensure the API provides total pages
          setLoading(false);
          setError(false);
        }
       
      } catch (error: any) {
        setLoading(false);
        setError(true);
        setErrorMsg(error.message || "An error occurred while fetching data.");
      }
    }

    useEffect(() => {
        fetchQuestions();
    }, [page,pageSize,searchTerm]);

    const confirmDelete = (id: string) => {
      setSelectedQuestionId(id);
      toggleModal();
    };
  
    const handleDelete = async () => {
      if (selectedQuestionId !== null) {
        try {
          await deleteQuestionApi(selectedQuestionId);
          setQuestions((prevQuestions:any) => prevQuestions.filter((question:any) => question.id !== selectedQuestionId));
          toggleModal();
          toast.success(t("question.Question deleted successfully"));
        } catch (error: any) {
          alert(error.message || "An error occurred while deleting the question.");
        }
      }
    };
    
 

  return (
    <div className="root">
    <Breadcrumb>
      <BreadcrumbItem>{t("header.you_are_here")}</BreadcrumbItem>
      <BreadcrumbItem active  style={{ paddingRight: '10px' }} 
      >{t("question.Question Catalog")}</BreadcrumbItem>
    </Breadcrumb>
    <h5 className="mb-lg">{t("question.Question Catalog")}</h5>
   <div className="container_info" style={{padding:'40px 20px',backgroundColor:'var(--widget-bg)'}}>
      <div className="d-flex justify-content-between my-2">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={t("question.search_placeholder") || ''}
          className="search-input"
        />
       <button className="submit-button4 " 
        onClick={() => navigate('/createQuestion')}><MdOutlineAdd size={20} />
        {t("question.Create")}</button>
      </div>
      <table className="styled-table">
          <thead className="table-dark">
            <tr>
              <th style={{ width: '30%' }}>{t("question.Question")}</th>
              <th style={{ width: '10%' }}>{t("question.Category")}</th>
              <th style={{ width: '20%' }}>{t("question.Risk")}</th>
              <th style={{ width: '20%' }}>{t("question.Control")}</th>
              <th style={{ width: '10%' }}>{t("question.Type")}</th>
              <th>{t("question.actions")}</th>
            </tr>
          </thead>
          <tbody>
            {questions.map((item:any) => (
              <tr key={item.id}>
                <td>{ i18n.language === 'ar' ? item.question_ar : item.question_en}</td>
                <td>{item?.category?.name}</td>
                <td>{item?.risks?.map((risk: any) => risk?.risk?.name).join(", ")}</td>
                <td>{item?.controls?.map((control: any) => control?.control?.description).join(", ")}</td>
                <td>
                  <span className="badge" style={{backgroundColor:'#4cc6dd'}}>
                    {item.question_type === 'textarea' && t("question.Text")}
                    {item.question_type === 'multiple_choice' && t("question.Multiple Choice")}
                    {item.question_type === 'single_choice' && t("question.Single Choice")}
                    
                    {item.question_type === 'compliance_related' && t("question.Related to compliance")}
                    {item.question_type === 'risk_related' && t("question.Related to risk")}
                  </span>
                </td>
                <td>



                <div className='d-flex'>
<button
    className="action-button action-button-warning"
    onClick={() => navigate(`/updateQuestion/${item.id}`)}
    title={String(t("question.Edit") || "Edit")}
  >
    <MdOutlineEdit size={20} />
  </button>
  <button
    className="action-button-danger"
    onClick={() => confirmDelete(item.id)}
  >
    <MdOutlineDelete size={20} />
  </button>

</div>
</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

       {/* Pagination */}
       <div className="pagination-controls mt-5">
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setPage(1)}
                  disabled={page ===1}
                >
                  {"<<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() => setPage((prev) => Math.max(prev - 1,1))}
                  disabled={page === 1}
                >
                  {"<"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setPage((prev) =>
                      Math.min(
                        prev + 1,
                        totalPages 
                      )
                    )
                  }
                  disabled={
                    page >= totalPages 
                  }
                >
                  {">"}
                </button>{" "}
                <button
                  className="btn btn-warning btn-sm text-white"
                  onClick={() =>
                    setPage(
                      totalPages 
                    )
                  }
                  disabled={
                    page >= totalPages 
                  }
                >
                  {">>"}
                </button>{" "}
                <span>
                  {t("question.page")}
                   {page} {t("question.to")} {totalPages}
                </span>
              </div>
              <Modal
        className="p-5"
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={String(t("surveys.Confirm Deletion") || "Confirm Deletion")}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
      >
        <p id="delete-modal-description" className="m-3">
          {t("question.Are you sure you want to delete this question? This action cannot be undone.")}
        </p>
        <div className="d-flex justify-content-end gap-2 p-3">
          <button className="btn btn-cancle" onClick={toggleModal} aria-label={String(t("surveys.Cancel") || "Cancel")}>
            {t("surveys.Cancel")}
          </button>
          <button className="btn btn-danger" onClick={handleDelete} aria-label={String(t("question.Delete") || "Delete")}>
            <i className="bi bi-trash-fill me-2"></i>
            {t("question.Delete")}
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default QuestionTable;